import {
  commonGetters,
  commonActions,
  commonMutations
} from '@/store/store_utils'
import { getAxiosObject } from '@/utils/library'
import { toStateName } from '@/utils/convert_string'

const dataName = 'measurementResultItems'
const keys = ['measurementResultId']

const state = {
  measurementResultItems: [],
  updatedAt: '20101010101010'
}
keys.forEach(key => {
  state[toStateName(key)] = null
})

const getters = {
  ...commonGetters(dataName, ['getUpdatedAt'], {
    filterDel: true,
    getDataBy: keys
  })
}

const actions = {
  ...commonActions(['setData', 'setUpdatedAt', 'updateAfter']),
  async fetchDataByMeasurementResultId({ commit }, measurementResultId) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.get('/measurement-result-items', {
        params: {
          measurementResultId
        }
      })
      if (res.status === 200) {
        commit('updateAfter', res.data.measurementResultItems)
        return 'success'
      }
    } catch {
      return 'failure'
    }
  }
}

const mutations = {
  ...commonMutations(dataName, ['setData', 'setUpdatedAt', 'updateAfter'], {
    setDataBy: keys
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
